/**
 * Facebook Embed Extractor
 *
 * Purpose:
 * - Extract iframe src from legacy pasted Facebook iframe HTML.
 */

/**
 * Extract iframe src URL from a piece of HTML containing an iframe.
 */
export function extractFacebookIframeSrcFromHtml(html: string): string | null {
    const raw = String(html || "");
    if (!raw) {
        return null;
    }

    const iframeMatch = raw.match(/<iframe[^>]*facebook\.com[^>]*>[\s\S]*?<\/iframe>/i);
    const originalIframe = iframeMatch ? iframeMatch[0] : raw.match(/<iframe[^>]*facebook\.com[^>]*>/i)?.[0];
    if (!originalIframe) {
        return null;
    }

    const srcMatch = originalIframe.match(/src=["']([^"']*)["']/i);
    if (!srcMatch || !srcMatch[1]) {
        return null;
    }

    return srcMatch[1];
}

/**
 * Extract the original Facebook post URL from a legacy plugins/post.php iframe embed.
 * Example embed src:
 *   https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2F...&show_text=true&width=500
 */
export function extractFacebookPostUrlFromEmbedHtml(html: string): string | null {
    const raw = String(html || "");
    if (!raw) {
        return null;
    }

    const src = extractFacebookIframeSrcFromHtml(raw);
    if (!src) {
        return null;
    }

    const normalizedSrc = src.replace(/&amp;/g, "&");

    try {
        const url = new URL(normalizedSrc, "https://www.facebook.com");
        const href = url.searchParams.get("href");
        if (href) {
            try {
                return decodeURIComponent(href);
            } catch {
                return href;
            }
        }
    } catch {
        // ignore
    }

    const match = normalizedSrc.match(/[?&]href=([^&]+)/i);
    if (!match || !match[1]) {
        return null;
    }

    try {
        return decodeURIComponent(match[1]);
    } catch {
        return match[1];
    }
}
